// export const baseUrl = 'https://ncpti.su/api/';
export const baseUrl = '/api/';